module.exports = __webpack_public_path__ + "static/230921_HSE_Personalie_AndreaDeSantis_ENG_final-72cf248e9c342e27c18af71dad313ef3.pdf";